import React from 'react';
import { observer, inject } from 'mobx-react';
import { EditImage } from 'client/shared/components';
import Navigation from './navigation';

@inject('artistStore')
@observer
class ArtistGreeting extends React.Component {
	render() {
		const { artistStore } = this.props;

		if (artistStore.isLoading) {
			<h1>Header Loading...</h1>
		}
		const artist = artistStore.loggedInArtist;
		const { name } = artist;

		return (
			<div style={{'textTransform': 'uppercase', 'fontSize': '1.3em'}}>{ name }</div>
		);
	}
}

@inject('apiStore', 'artistStore', 'userStore')
@observer
export default class Header
extends React.Component {
	render() {
		const { userID, artistStore } = this.props;

		if (artistStore.isLoading) {

			return (
				<h1>Header Loading...</h1>
			);
		}

		return (
			<div style={{position: 'relative', height: '6vh'}}>
				<div className="artist-header grid-x" data-ta="artist-header">
					<div className="grid-x" style={{'lineHeight': '3.3vw', 'alignItems': 'center'}}>
						<div className="logo-mini"></div>
						{/* <ArtistGreeting userID={userID}/> */}
						Artist CMS
						<span style={{fontSize:'0.6em', marginLeft: '0.5vw'}}>[BETA]</span>
					</div>
					<Navigation />
				</div>
			</div>
		);
	}
}
